// @flow
import React from 'react';
import { AppMobileHeader } from '../../../../blocks';

export default class PatientReceipts extends React.Component<any> {
  render() {
    return (
      <div className="appContent">
        <AppMobileHeader title="PatientReceipts" className="showBack" />
        PatientReceipts
      </div>
    );
  }
}
